import i18nCountries, { Alpha2Code } from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import zhLocale from 'i18n-iso-countries/langs/zh.json';
import { Locale } from './languages';

i18nCountries.registerLocale(enLocale);
i18nCountries.registerLocale(frLocale);
i18nCountries.registerLocale(zhLocale);

/**
 * Formats a country code into a full name with its code
 * Example: "FR" -> "France (FRA)"
 * @param countryCode - The ISO 3166-1 alpha-2 country code
 * @param locale - The locale to use for the country name (en, fr, or zh)
 * @returns The formatted country name with its alpha-3 code, or the original code if not found
 */
export const formatCountry = (countryCode: Alpha2Code, locale: Locale = 'en'): string =>
  i18nCountries.getName(countryCode, locale) && i18nCountries.alpha2ToAlpha3(countryCode)
    ? `${i18nCountries.getName(countryCode, locale)} (${i18nCountries.alpha2ToAlpha3(countryCode)})`
    : countryCode;

export const format2CodeTo3Code = (countryCode: Alpha2Code): string => `(${i18nCountries.alpha2ToAlpha3(countryCode)})`;

/**
 * Returns the alpha-3 ISO code for a country, or the original value if unknown.
 * Use this wherever a country *code only* is rendered to users — clients require alpha-3 (e.g. "USA" not "US").
 */
export const formatCountryCode = (countryCode: string | undefined | null): string => {
  if (!countryCode) {
    return '';
  }
  const alpha3 = i18nCountries.alpha2ToAlpha3(countryCode as Alpha2Code);
  return alpha3 || countryCode;
};
